'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    tab: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      justifyContent: 'center',
      borderBottomStyle: 'solid',
      borderBottomColor: 'transparent',
      transition: theme.transition(['border-bottom-color']),
      boxSizing: 'border-box',
      '&:last-child': {
        marginRight: '0 !important'
      },
      '&:first-child': {
        marginLeft: '0 !important'
      },
      '&.active, &:hover': {
        borderBottomColor: theme.tab.activeColor,
        color: theme.tab.activeColor,
        '& $icon': {
          '& .fill': {
            fill: theme.tab.activeColor
          },
          '& .stroke': {
            stroke: theme.tab.activeColor
          }
        },
        '&.disabled': {
          borderBottomColor: theme.tab.disabledColor
        }
      },
      '&.error.active': {
        color: theme.tab.errorColor,
        borderBottomColor: theme.tab.errorColor,
        '& $icon': {
          '& .fill': {
            fill: theme.tab.errorColor
          },
          '& .stroke': {
            stroke: theme.tab.errorColor
          }
        }
      },
      '&.active:hover': {
        cursor: 'default'
      },
      '&.disabled, &.disabled.error': {
        color: theme.tab.disabledColor,
        cursor: 'default',
        '& $icon': {
          '& .fill': {
            fill: theme.tab.disabledColor
          },
          '& .stroke': {
            stroke: theme.tab.disabledColor
          }
        }
      },
      '&.hidden': {
        display: 'none'
      }
    },
    fixed: {
      width: 0,
      flexGrow: 1
    },
    auto: {
      maxWidth: 300,
      minWidth: 20
    },
    icon: {
      '& .fill': {
        fill: theme.tab.color,
        transition: theme.transition(['fill'])
      },
      '& .stroke': {
        stroke: theme.tab.color,
        transition: theme.transition(['stroke'])
      }
    },
    leftIcon: {
      '& + $label': {
        marginLeft: 8
      }
    },
    rightIcon: {
      '$label + &': {
        marginLeft: 8
      }
    },
    label: {
      color: 'inherit',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    small: {
      padding: '2px 0 8px 0',
      borderBottomWidth: theme.tab.smallHeightUnderline,
      '&$indentsmall': {
        margin: '0 8px'
      },
      '&$indentmedium': {
        margin: '0 12px'
      },
      '&$indentlarge': {
        margin: '0 16px'
      }
    },
    medium: {
      padding: '4px 0 12px 0',
      borderBottomWidth: theme.tab.mediumHeightUnderline
    },
    indentsmall: {
      margin: '0 12px'
    },
    indentmedium: {
      margin: '0 16px'
    },
    indentlarge: {
      margin: '0 22px'
    }
  };
};